import type { ComponentPropsWithRef } from "react";
import { styled } from "styled-components";

const StyledAnchor = styled.a`
  &:link,
  &:visited {
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const AnchorLink = (props: ComponentPropsWithRef<"a">) => <StyledAnchor {...props} />;
